import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { IonToggle } from '@ionic/angular';
import { Component, Input, OnInit, Optional, Self, ViewChild } from '@angular/core';

@Component({
    selector: 'c-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    standalone: false
})
export class ToggleComponent<T = any> implements OnInit, ControlValueAccessor {
  @Input() label: string | undefined;
  @Input() subLabel = '';
  @Input() labelLink: string | undefined;
  @Input() labelLinkTxt: string | undefined;
  @Input() readonly: boolean | undefined;
  @Input() hidden: boolean | undefined;
  @Input() errorPlacement: string | undefined;
  @Input() info: string | undefined;
  @Input() value: string | boolean | undefined;
  @Input() loading: boolean | undefined;
  @Input() showError = true;
  @Input() formInline: boolean;
  @Input() uppercase: boolean;
  @Input() inline: boolean;

  @ViewChild('toggle') toggle: IonToggle | undefined;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl?.control as FormControl;
  }

  ngOnInit() {}

  writeValue(value: any): void {}

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
